var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center-table-list",staticStyle:{"position":"relative"}},[_c('div',{attrs:{"id":"eot"}},[_c('my-evidence')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }